export default "__VITE_ASSET__C26OoXNR__"